// extracted by mini-css-extract-plugin
export default {"backButtonContainer":"styles_backButtonContainer__6iq0G","title":"styles_title__SRSDs","slide-in-bottom":"styles_slide-in-bottom__stODD"};